<template>
    <div>
        <v-modal
            :open="open"
            class="c-modal_visit_add">
            <form @submit.prevent="createVisit('visit-add-form')" data-vv-scope="visit-add-form">
                <h2>Rozpoczynanie wizyty</h2>
                <form-row>
                    <form-select
                        label="Wybierz problem pacjenta z listy"
                        data-vv-as="problem"
                        v-model="issueId"
                        :options="visitIssues"
                        v-validate="'required'"
                        btn="green"
                        btn-label="Dodaj nowy"
                        @click="$refs.issueAddModal.$emit('open')">
                    </form-select>
                </form-row>

                <form-row align="between">
                    <v-btn
                        type="green"
                        role="submit"
                        has-loader
                        :loading="isSaving">
                        Rozpocznij wizytę
                    </v-btn>
                    <v-btn
                        type="white"
                        @click="cancel">
                        Anuluj
                    </v-btn>
                </form-row>
            </form>
            <v-loader :loading="isFetching"></v-loader>
        </v-modal>
        <issue-add-modal ref="issueAddModal" @success="selectIssue"></issue-add-modal>
        <visit-confirm-modal
            ref="visitConfirmModal"
            @ok="submit"
            @cancel="cancel">
        </visit-confirm-modal>
    </div>

</template>


<script>

import IssueAddModal from 'Components/Issue/IssueAddModal'
import VisitConfirmModal from 'Components/Visit/VisitConfirmModal'
import {mapGetters} from 'vuex'
import {FormSelect, FormRow} from 'Components/Form'
import VLoader from 'Components/VLoader'
import VModal from 'Components/VModal'
import VBtn from 'Components/VBtn'

import moment from 'moment'

export default {

    name: 'VisitAddModal',

    data() {
        return {
            open: false,
            isFetching: true,
            isSaving: false,
            patientId: null,
            issueId: 0,
            event: {}
        }
    },

    computed: {
        ...mapGetters(['visitIssues', 'errors']),

        isEventToday() {
            const today = moment().format('YYYY-MM-DD')
            return (today === this.event.date)
        }
    },

    methods: {
        cancel() {
            this.open = false
            this.$emit('cancel')
        },
        createVisit(scope) {
            this.$validator.validateAll(scope).then((isValid) => {
                if (isValid) {
                    if (this.isEventToday) {
                        this.submit()
                    } else {
                        this.$refs.visitConfirmModal.$emit('open', this.event)
                    }
                }
            })

        },
        submit() {
            this.isSaving = true
            return this.$store.dispatch('VISIT_CREATE', {
                event_id: this.event.id,
                issue_id: this.issueId
            }).then((res) => {
                this.$router.push({
                    name: 'PatientVisitEdit',
                    params: {
                        id: this.patientId,
                        id1: res.data.data.id
                    }
                })
            }).catch((e) => {
                this.isSaving = false
                this.$alert.error('Rozpoczynanie wizyty', e.response.data.message)
            })
        },
        selectIssue(issue) {
            this.$nextTick(() => {
                this.issueId = issue.id
            })
        }
    },

    mounted() {
        this.$on('open', (event, patientId) => {

            this.event = event
            this.patientId = patientId

            this.open = true
            this.isFetching = true

            this.$store.dispatch('VISIT_ISSUES_FETCH', patientId).then(() => {
                this.isFetching = false
                this.issueId = null
                this.$validator.reset()
            }).catch((error) => {
                this.$alert.error('Rozpoczynanie wizyty', error.response.data.message)
                this.open = false
            })
        })
    },

    beforeDestroy() {
        this.$off('open')
    },

    components: {
        IssueAddModal,
        VisitConfirmModal,
        FormRow,
        FormSelect,
        VModal,
        VLoader,
        VBtn
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-modal_visit_add {
    .c-modal__inner {
        max-width: 550px;
    }
}

</style>
